import TextInput from "../../../../../../../Components/UI/Form/TextInput";

// Prop names are kept as-is so existing call sites on this page are unchanged.
export default function AddressForm(props) {
  const {
    Label,
    Name,
    Data,
    Handler,
    Required = true,
    Type = "text",
    Multiline = false,
    Row = 3,
    PlaceHolder = Label,
    Disabled = false,
    Validation = {},
  } = props;

  return (
    <TextInput
      label={Label}
      name={Name}
      value={Data}
      onChange={Handler}
      type={Type}
      placeholder={PlaceHolder}
      required={Required}
      disabled={Disabled}
      multiline={Multiline}
      rows={Multiline ? Row || 3 : undefined}
      inputProps={Validation}
    />
  );
}
